import React from "react";
import _ from "lodash";

// Input component
export const IconInput = React.forwardRef(
    (
        {
            label,
            id,
            name,
            type = "text",
            placeholder = "",
            disabled = false,
            required = false,
            isHideLabel = false,
            className = "",
            subTitle = "",
            subRequired = false,
            errors = null,
            errorName = "",
            iconImage = null,
            src = "",
            ...props
        },
        ref
    ) => {
        const msg = _.get(errors || {}, errorName || name);
        const InputComponent = type === "textarea" ? 'textarea' : "input"
        return (
            <div className="w-full font-urbanist">
                {(!!label || !isHideLabel) && (
                    <label
                        htmlFor={id}
                        className={`block text-lg font-semibold mb-1 ${disabled ? "text-gray-500" : "text-white"}`}
                    >
                        {label} {required && <span className="text-red-600">*</span>}
                    </label>
                )}
                {
                    !!subTitle &&
                    <p className="text-xs text-gray-400 mb-1">
                        {subTitle}
                        {subRequired && <span className="text-red-600">*</span>}
                    </p>
                }
                <div className="bg-[#22262E] flex rounded-lg border border-gray-700 focus-within:ring-2 focus-within:ring-white transition-colors px-1 py-1">
                    <button
                        type="button"
                        className="bg-gray-700 text-gray-300 rounded-md flex items-center py-1 px-3 cursor-default"
                    >
                        {
                            !!iconImage ? iconImage() :
                                <img
                                    src={src || "https://flagcdn.com/in.svg"}
                                    alt="IN"
                                    className="w-5 h-3 object-cover rounded-sm"
                                />

                        }
                    </button>
                    <InputComponent
                        ref={ref}
                        id={id}
                        name={name}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        required={required}
                        className={`bg-[#22262E] border-0 rounded-r-lg w-full py-1 px-3 text-gray-400 placeholder:text-gray-500 focus:outline-none ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-400"} ${className}`}
                        {...props}
                    />
                </div>

                {
                    !!msg &&
                    <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>
                }
            </div>
        )
    }
);
